<template>
  <div class="view-site-page">
    <!--     <b-modal v-model="showSiteMap" hide-header hide-footer centered size="xl">
      <b-carousel
        id="carousel-1"
        :controls="siteMap.length > 1"
        indicators
        :interval="0"
      >
        <b-carousel-slide v-for="map in siteMap" :key="map.id">
          <template v-slot:img>
            <div v-if="siteMap.length !== 0">
              <b-img
                class="w-100"
                rounded
                alt="Site Map"
                :src="map.url"
              ></b-img>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </b-modal> -->

    <b-container class="p-relative">
      <div
        class="header-text-container"
        :style="isMobile ? 'top: 75px' : ''"
        v-if="showHeader"
      >
        <div class="header-text">{{ $route.params.name }}</div>
      </div>

      <div class="header-actions-container" :style="isMobile ? 'left: 0' : ''">
        <search-all
          v-show="!isMobile"
          @open="showHeader = isMobile ? false : true"
          @close="showHeader = true"
        />

        <br v-show="isMobile" />

        <b-button
          class="py-2 mx-3 border-0"
          :class="isMobile ? 'small-btn px-0' : 'px-3'"
          @click="
            $router.push({
              name: 'board.new-main-board-page',
              params: {
                id: $route.params.id,
                name: $route.params.name
              }
            })
          "
        >
          <b-img
            width="12"
            class="rounded-0 mr-2"
            :src="require('@/assets/icons/plus.svg')"
          ></b-img>
          <b>Main Switch Board</b>
        </b-button>

        <b-button
          class="py-2 border-0"
          :class="isMobile ? 'small-btn px-0' : 'px-3'"
          @click="addDistributionBoard"
          :disabled="!boardList.length"
        >
          <b-img
            width="12"
            class="rounded-0 mr-2"
            :src="require('@/assets/icons/plus.svg')"
          ></b-img>
          <b>Distribution Board</b>
        </b-button>
      </div>
    </b-container>

    <div class="px-3 mobile__search" v-show="isMobile">
      <search-all
        @open="showHeader = isMobile ? false : true"
        @close="showHeader = true"
      />
    </div>

    <div class="cover-image">
      <div class="cover-overlay"></div>
    </div>

    <div class="subheader-container">
      <b-container class="p-relative">
        <div class="subheader-text-container" v-if="!isMobile">
          <b-breadcrumb
            :items="items"
            class="pl-0 bg-transparent"
          ></b-breadcrumb>
        </div>
        <div
          class="subheader-actions-container"
          :style="isMobile ? 'left: 15px' : ''"
        >
          <!-- <b-button
            id="tooltip-site-map"
            variant="outline-primary"
            class="add-btn mr-3"
            :style="siteMap.length === 0 ? 'opacity: 0.65' : ''"
            @click="siteMap.length > 0 ? (showSiteMap = true) : null"
          >
            <b>Site Map</b>
          </b-button>
          <b-tooltip
            :disabled.sync="siteMap.length > 0"
            target="tooltip-site-map"
            placement="bottom"
            >No maps uploaded for this site yet</b-tooltip
          > -->

          <!-- <b-button
            variant="outline-primary"
            class="add-btn"
            @click="
              $router.push({
                name: 'site.view-change-log',
                params: {
                  id: $route.params.id,
                  name: $route.params.name,
                  activeBoard: $route.params.topMostParentId
                }
              })
            "
          >
            <b>Change Log</b>
          </b-button> -->
        </div>
      </b-container>
    </div>

    <b-container class="py-0 pt-4" :class="isMobile ? '' : 'custom-container'">
      <compliance-list
        ref="complianceList"
        v-if="canShowTabs"
        :site="site"
      ></compliance-list>

      <b-tabs v-if="canShowTabs" v-model="tabIndex" content-class="my-5">
        <b-tab title="Boards" title-link-class="nav-title" @click="setTab(0)">
          <div class="mb-3">
            <b>Main Switchboards</b>
            <span class="grey--text ml-2">({{ boardListMeta.total }})</span>
            <div class="text-right" style="margin-top: -40px;">
              <b-button
                class="load-btn mr-3 border-0"
                :disabled="boardListMeta.current_page === 1"
                :style="boardListMeta.current_page > 1 ? '' : 'opacity: 0.5'"
                @click="loadPrevious"
              >
                <b-icon scale="0.8" icon="chevron-left" color="grey"></b-icon>
              </b-button>

              <b-button
                class="load-btn border-0"
                :disabled="
                  boardListMeta.current_page === boardListMeta.last_page
                "
                :style="
                  boardListMeta.current_page < boardListMeta.last_page
                    ? ''
                    : 'opacity: 0.5'
                "
                @click="loadNext"
              >
                <b-icon scale="0.8" icon="chevron-right" color="grey"></b-icon>
              </b-button>
            </div>
          </div>

          <b-row
            :class="isMobile ? 'd-flex align-items-center flex-column' : ''"
          >
            <b-col
              class="c-pointer"
              :style="
                isMobile
                  ? 'min-width: 250px; max-width: 250px;'
                  : 'min-width: 20%; max-width: 20%;'
              "
              v-for="(board, index) in boardList"
              :key="board.id"
              @click="onClickMainBoard(index)"
            >
              <board-item
                :board="board"
                :version="2"
                :is-active="currentBoard === index"
              />
            </b-col>
          </b-row>

          <b-container
            class="board-tree mx-auto mt-3 mb-5 pt-4 d-flex"
            ref="boardContainer"
            :class="boardClass"
            @mouseover="onBoardMouseOver"
          >
            <div>
              <site-tree
                :json="boardList[currentBoard]"
                :main-board-id="
                  boardList[currentBoard]
                    ? boardList[currentBoard].board_id
                    : null
                "
              />
            </div>
          </b-container>
        </b-tab>
        <b-tab
          v-if="canViewCompliance"
          title="Compliance"
          title-link-class="nav-title"
          @click="setTab(1)"
        >
          <compliance-form @updated="refreshCompliance" />
        </b-tab>
        <b-tab
          v-if="canViewUser"
          title="Users"
          title-link-class="nav-title"
          @click="setTab(2)"
        >
          <user-list v-if="canViewUser" ref="userList" :site="site" />
        </b-tab>
        <b-tab title="Site Map" title-link-class="nav-title" @click="setTab(3)">
          <b-carousel
            id="carousel-1"
            :controls="siteMap.length > 1"
            indicators
            :interval="0"
          >
            <b-carousel-slide v-for="map in siteMap" :key="map.id">
              <template v-slot:img>
                <div v-if="siteMap.length !== 0">
                  <b-img
                    class="w-100"
                    rounded
                    alt="Site Map"
                    :src="map.url"
                  ></b-img>
                </div>
              </template>
            </b-carousel-slide>
          </b-carousel>

          <h6 v-if="!siteMap || !siteMap.length">
            No maps uploaded for this site yet
          </h6>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import SearchAll from '@/components/buttons/SearchAll'
import BoardItem from '@/components/cards/BoardItem'
import SiteTree from '@/components/charts/SiteTree'
import UserList from '@/components/lists/site/UserList'
import ComplianceList from '@/components/lists/site/ComplianceList'
import ComplianceForm from '@/components/forms/site/ComplianceForm'
import { findIndex } from 'lodash'
import ZoomAndPan from '@/utils/ZoomAndPan'

const HASH = ['#boards', '#compliance', '#users', '#site-map']

export default {
  components: {
    SearchAll,
    BoardItem,
    SiteTree,
    UserList,
    ComplianceList,
    ComplianceForm
  },

  data() {
    return {
      addBoard: false,
      currentBoard: 0,
      boardClass: 'justify-content-center',
      loading: false,
      clicked: false,
      // showSiteMap: false,
      showHeader: true,
      tabIndex: 0
    }
  },

  computed: {
    ...mapState({
      boardList: state => state.site.boardList,
      boardListMeta: state => state.site.boardListMeta,
      site: state => state.site.siteDetails,
      user: state => state.auth.user
    }),

    listLimit() {
      return this.isMobile ? 1 : 5
    },

    items() {
      return [
        { text: 'Home', href: '/dashboard' },
        { text: this.$route.params.name, href: '#' }
      ]
    },

    siteMap() {
      return this.site ? this.site.site_map : []
    },

    canShowTabs() {
      return !!this.site && !!this.user
    },

    canViewCompliance() {
      return this.user.is_admin || this.site.canViewCompliance
    },

    canViewUser() {
      return this.user.is_admin || this.site.canViewUser
    }
  },

  methods: {
    ...mapActions({
      getSite: 'site/getSiteDetails',
      getSiteBoards: 'site/getSiteBoards'
    }),

    ...mapMutations({
      clearSiteDetails: 'site/clearSiteDetails',
      clearSiteBoardList: 'site/clearSiteBoardList'
    }),

    addDistributionBoard() {
      this.setTab(0)

      this.$root.$emit('showPlusSign', true)
      window.scrollTo({
        top: window.innerHeight / 2,
        left: 0,
        behavior: 'smooth'
      })
    },

    autoScrollToCenter() {
      let t = this
      setTimeout(function() {
        t.boardClass =
          t.$refs.boardContainer.scrollWidth <=
          t.$refs.boardContainer.clientWidth
            ? 'justify-content-center'
            : ''
        t.$refs.boardContainer.scrollLeft =
          t.$refs.boardContainer.scrollWidth / 2
      }, 100)
    },

    onClickMainBoard(index) {
      this.$root.$emit('showPlusSign', false)
      this.currentBoard = index
      this.autoScrollToCenter()
    },

    loadPrevious() {
      if (this.boardListMeta.current_page > 1) {
        this.fetchSiteBoards(this.boardListMeta.current_page - 1)
      }
    },

    loadNext() {
      if (this.boardListMeta.current_page < this.boardListMeta.last_page) {
        this.fetchSiteBoards(this.boardListMeta.current_page + 1)
      }
    },

    async fetchSite(clear = true) {
      if (this.loading) return
      this.loading = true

      if (clear) {
        this.clearSiteDetails()
      }

      await this.getSite(this.$route.params.id)
        .then(() => {
          this.loading = false

          if (clear) {
            this.fetchSiteBoards()
          }
        })
        .catch(() => {
          this.$router.push({
            name: 'page-not-found'
          })
        })
    },

    async fetchSiteBoards(page = 1) {
      if (this.loading) return
      this.loading = true
      await this.getSiteBoards({
        site_id: this.$route.params.id,
        page: page,
        limit: this.listLimit
      })
      this.loading = false

      if (!this.clicked && this.$route.params.activeBoard) {
        const index = findIndex(this.boardList, {
          board_id: this.$route.params.activeBoard
        })
        if (
          index === -1 &&
          this.boardListMeta.last_page > this.boardListMeta.current_page
        ) {
          this.fetchSiteBoards(this.boardListMeta.current_page + 1)
        } else {
          this.currentBoard = index
          this.clicked = true
        }
      }

      this.autoScrollToCenter()
    },

    async refreshCompliance() {
      this.fetchSite(false)
    },

    setTab(index) {
      if (index === this.tabIndex) return
      this.tabIndex = index
      this.$router.push({
        name: 'site.view-site-page',
        hash: HASH[index]
      })
    },

    /**
     * !@REFACTOR: Better way of initializing the zoom and pan
     * feature when its on the board tab?
     */
    onBoardMouseOver() {
      ZoomAndPan(this.$refs.boardContainer)
    }
  },

  created() {
    this.clearSiteBoardList()
    this.tabIndex = HASH.indexOf(this.$route.hash)
    this.fetchSite()
  }
}
</script>

<style lang="scss" scoped>
.view-site-page /deep/ {
  .compliance-list {
    margin-bottom: 20px;

    ul {
      li {
        padding-bottom: 5px;
      }
    }
  }
}

.col {
  padding: 0 12px;
  margin-bottom: 30px;
}
.btn {
  height: 46px;
  background: #ffffff33 0% 0% no-repeat padding-box;
}
.btn-outline-primary:hover {
  color: #106fdc;
}
.add-btn {
  height: 40px;
  width: 155px;
}
.load-btn {
  background: #f2f3f6;
  padding: 0 10px;
  border-radius: 4px;
  height: 40px;
}
.small-btn {
  width: 45%;
  font-size: 12px;
}
.empty-container {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border-radius: 10px;
  height: 240px;
  text-align: center;
  padding-top: 85px;
  box-shadow: none;
}
.header-actions-container {
  position: absolute;
  color: white;
  top: 100px;
  right: 10px;
  z-index: 2;
  text-shadow: 0px 4px 8px #00000066;
}
.header-text-container {
  position: absolute;
  color: white;
  top: 100px;
  z-index: 2;
}
.header-text {
  font-size: 28px;
  font-weight: bold;

  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
  max-width: calc(100vw - 80px);
}
.subheader-container {
  background-color: #f5f5f5;
  height: 75px;
}
.subheader-text {
  font-size: 12px;
}
.subheader-text-container {
  position: absolute;
  top: 15px;
}
.subheader-actions-container {
  position: absolute;
  top: 15px;
  right: 15px;
  text-shadow: 0px 4px 8px #00000066;
}
.cover-image {
  width: 100%;
  min-height: 180px;
  background: url('~@/assets/images/cover.jpeg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.9;
}
.cover-overlay {
  width: 100%;
  min-height: 180px;
  background-blend-mode: multiply;
  background: transparent url('~@/assets/images/overlay.svg') 0% 0% no-repeat
    padding-box;
  background-size: cover;
  background-repeat: no-repeat;
}
.board-tree {
  max-height: 600px;
  overflow: auto;
  border: 1px solid #d6d6d6;
  background: #f7f7f7;
}
.breadcrumb-item {
  font-weight: bold;
}
.breadcrumb-item + .breadcrumb-item.active {
  font-weight: normal;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: '\203A';
}
.mobile__search {
  position: absolute;
  right: 0px;
  top: 72px;
  z-index: 2;
}
</style>
